import { NavState } from '../../interfaces/nav/NavState';
import additionalInfoBg from '../../assets/images/additional-info-bg.svg';
import servicesBg from '../../assets/images/gallery-bg.svg';
import galleryBg from '../../assets/images/services-bg.svg';

const initialState: NavState = {
  mainMenu: {
    items: [
      {
        label: 'header.menu.home.label',
        url: 'header.menu.home.url',
        title: 'header.menu.home.title',
      },
      {
        label: 'header.menu.services.label',
        url: 'header.menu.services.url',
        title: 'header.menu.services.title',
      },
      {
        label: 'header.menu.additionalInfo.label',
        url: 'header.menu.additionalInfo.url',
        title: 'header.menu.additionalInfo.title',
      },
      {
        label: 'header.menu.gallery.label',
        url: 'header.menu.gallery.url',
        title: 'header.menu.gallery.title',
      },
    ],
  },
  mobileMenu: {
    items: [
      {
        label: 'header.menu.home.label',
        url: 'header.menu.home.url',
        title: 'header.menu.home.title',
      },
      {
        label: 'header.menu.services.label',
        url: 'header.menu.services.url',
        title: 'header.menu.services.title',
      },
      {
        label: 'header.menu.additionalInfo.label',
        url: 'header.menu.additionalInfo.url',
        title: 'header.menu.additionalInfo.title',
      },
      {
        label: 'header.menu.gallery.label',
        url: 'header.menu.gallery.url',
        title: 'header.menu.gallery.title',
      },
    ],
  },
  preFooterPages: {
    items: [
      {
        label: 'header.menu.services.label',
        url: 'header.menu.services.url',
        title: 'header.menu.services.title',
        description: 'header.menu.services.description',
      },
      {
        label: 'header.menu.additionalInfo.label',
        url: 'header.menu.additionalInfo.url',
        title: 'header.menu.additionalInfo.title',
        description: 'header.menu.additionalInfo.description',
      },
      {
        label: 'header.menu.gallery.label',
        url: 'header.menu.gallery.url',
        title: 'header.menu.gallery.title',
        description: 'header.menu.gallery.description',
      },
      {
        label: 'header.menu.getInTouch.label',
        url: 'header.menu.getInTouch.url',
        title: 'header.menu.getInTouch.title',
        description: 'header.menu.getInTouch.description',
      },
    ],
  },
  preFooterPagesModernTemplate: {
    items: [
      {
        label: 'header.menu.services.label',
        url: 'header.menu.services.url',
        title: 'header.menu.services.title',
        description: 'header.menu.services.description',
        image: servicesBg,
        color: '#FDE7E8',
      },
      {
        label: 'header.menu.additionalInfo.label',
        url: 'header.menu.additionalInfo.url',
        title: 'header.menu.additionalInfo.title',
        description: 'header.menu.additionalInfo.description',
        image: additionalInfoBg,
        color: '#FFF4DD',
      },
      {
        label: 'header.menu.gallery.label',
        url: 'header.menu.gallery.url',
        title: 'header.menu.gallery.title',
        description: 'header.menu.gallery.description',
        image: galleryBg,
        color: '#EDF1FF',
      },
    ],
  },
};

const navReducer = (state = initialState, action: { type: string }): NavState => {
  switch (action.type) {
    default:
      return state;
  }
};

export default navReducer;
